module.exports = __webpack_public_path__ + "static/media/_MIC2661.image.41b23671.png";